<template>
  <el-dialog :title="title" :visible.sync="show" width="700px" :before-close="closeDialog" append-to-body>
    <title-block v-if="titles[0].num">
      <template slot="title">{{titles[0].label}}</template>
      <div class="table mt-10">
        <el-row>
          <el-col :span="5">法定代表人</el-col>
          <el-col :span="7">{{ info.legalPersonName||'--' }}</el-col>
          <el-col :span="5">经营状态</el-col>
          <el-col :span="7">{{ info.regStatus||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">注册资本</el-col>
          <el-col :span="7">{{ info.regCapital||'--' }}</el-col>
          <el-col :span="5">实缴资本</el-col>
          <el-col :span="7">{{ info.actualCapital||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">成立日期</el-col>
          <el-col :span="7">
            <span v-if="info.estiblishTime">{{ info.estiblishTime.slice(0,10) }}</span>
            <span v-else>--</span>
          </el-col>
          <el-col :span="5">核准日期</el-col>
          <el-col :span="7">
            <span v-if="info.approvedTime">{{ info.approvedTime.slice(0,10) }}</span>
            <span v-else>--</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">统一社会信用代码</el-col>
          <el-col :span="7">{{ info.creditCode||'--' }}</el-col>
          <el-col :span="5">组织机构代码</el-col>
          <el-col :span="7">{{ info.orgNumber||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">纳税人识别号</el-col>
          <el-col :span="7">{{ info.taxNumber||'--' }}</el-col>
          <el-col :span="5">工商注册号</el-col>
          <el-col :span="7">{{ info.regNumber||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">企业类型</el-col>
          <el-col :span="7">{{ info.companyOrgType||'--' }}</el-col>
          <el-col :span="5">营业期限</el-col>
          <el-col :span="7">
            <span v-if="info.estiblishTime" class="mr-5">{{info.estiblishTime.slice(0,10) }} 至 </span>
            <span v-if="info.toTime">{{ info.toTime.slice(0,10) }}</span>
            <span v-else>无固定期限</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">登记机关</el-col>
          <el-col :span="7">{{ info.regInstitute||'--' }}</el-col>
          <el-col :span="5">人员规模</el-col>
          <el-col :span="7">{{ info.staffNumRange||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">曾用名</el-col>
          <el-col :span="7">{{ info.historyNames||'--' }}</el-col>
          <el-col :span="5">英文名</el-col>
          <el-col :span="7">{{ info.property3||'--' }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="5">简称</el-col>
          <el-col :span="7">{{ info.alias||'--' }}</el-col>
          <el-col :span="5">参保人数</el-col>
          <el-col :span="7">{{ info.socialStaffNum||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">所属地区</el-col>
          <!-- <el-col :span="7">{{ getBase(info.base) }}</el-col> -->
          <el-col :span="5">所属行业</el-col>
          <el-col :span="7">{{ info.industry||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">企业地址</el-col>
          <el-col :span="19">{{ info.regLocation||'--' }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5">经营范围</el-col>
          <el-col :span="19">{{ info.businessScope||'--' }}</el-col>
        </el-row>
      </div>
    </title-block>
  </el-dialog>
</template>

<script>
import titleBlock from './titleBarBlock'

export default {
  name: 'annualReportsDialog',
  components: {
    titleBlock
  },
  props: {
    title: {
      type: String,
      default: '企业年报'
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      show: false,
      titles: [
        { type: '', label: '企业简介', num: 1 },
        { type: '', label: '工商信息', num: 1 },
        { type: '', label: '高管信息', num: 1 },
        { type: '', label: '股东信息', num: 1 },
        { type: '', label: '变更信息', num: 1 },
        { type: '', label: '对外投资', num: 0 },
        { type: '', label: '分支机构', num: 0 },
        { type: '', label: '企业年报', num: 0 },
        { type: '', label: '相似企业', num: 0 },
      ],
    }
  },
  methods: {
    showDialog() {
      this.show = true
    },
    closeDialog() {
      this.show = false
    },
  },
};
</script>

<style scoped lang="stylus"></style>
